<template>
    <vs-row vs-justify="center" vs-align="center" class="full-height login-register-bg">
        <vs-col type="flex" vs-justify="center" vs-align="center" class="login-register-box" vs-lg="12" vs-xs="12">
            <vs-card class="mb-0">
                <div slot="header">
                  <h3 class="mb-1">Change password</h3>
                  <p class="mb-0">Please fill in new password</p>
                </div>

                <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger" :active="!formDataChanged">
                    <b>Please correct the following error(s):</b>
                    <ul class="common-list">
                        <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
                    </ul>
                </vs-alert>

                <form @submit="checkForm" novalidate="true">
                    <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" type="password" icon="lock" placeholder="Password" v-model="password"/>
                    <vs-input @keyup="changeLoginData" @change="changeLoginData" icon-after="true" size="large" class="w-100 mb-4 mt-2 vs-input-large" type="password" icon="lock" placeholder="Repeat password" v-model="password2"/>
                    <input class="btn-block btn btn-primary submit-button mt-3" @click.stop.prevent="onSubmit" type="submit" value="Change Password"/>
                </form>
                <div class="d-flex justify-content-center mt-3">
                    <span class="mr-1">Do you have an account?</span><router-link to="/site/login"> Login</router-link>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
</template>

<script>
    import {AuthService} from "../../services/auth.service";
    import NProgress from 'nprogress';

    export default {
        name: 'ChangePassword',
        data:()=>({
            password:'',
            password2:'',
            errors:[],
            formDataChanged: false
        }),
        methods:{
            close() {
                this.$router.push({name:'forgotpassword'});
            },

            changeLoginData: function(e){
              if (e.key !== 'Enter') {
                this.errors = [];
              }
            },

            checkForm:function(e) {
                this.errors = [];
                this.formDataChanged = false;
                if(!this.password) this.errors.push("Password required.");
                if (this.password !== this.password2) {
                    this.errors.push('Passwords must be equal')
                }
                if(!this.errors.length) return true;
                e.preventDefault();
            },

            onSubmit: function(e){
                if (this.checkForm(e)) {
                    NProgress.start();
                    AuthService.makeRestore(this.$route.params.token, this.password)
                        .then( () => {
                            this.$vs.notify({
                                color: "success",
                                title: 'Success!',
                                text: 'Password is reset'
                            });

                            this.$store.dispatch('user/GET')
                              .then(() => this.$router.push('/'))
                              .catch( error => {
                                  NProgress.done();
                                  error.alert()
                              });
                        })
                        .catch( error => {
                            NProgress.done();
                            error.apply()
                        });
                } else {
                    e.preventDefault();
                }
            }
        }
    }
</script>

<style>
    .login-register-bg{
        margin:0 auto;
        background:url(../../assets/images/background/auth-bg.jpg) no-repeat center center;
    }
    .login-register-box{
        max-width:400px;
    }

</style>
